export default "__VITE_ASSET__DIL0tF82__"